import Link from "next/link";
import { cn } from "../utils/className";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumb = ({ items, className }: BreadcrumbProps) => {
  return (
    <nav className={cn("breadcrumb mt-5 lg:mt-0 ml-5 lg:ml-0", className)}>
      <ol className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {item.href ? (
              <Link
                href={item.href}
                className="text-slate-300 hover:text-white hover:underline"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-slate-50 font-medium">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <span className="text-gray-400 ml-2">/</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
